import React from 'react';

import StepWithOptions from 'containers/Quiz/StepWithOptions';

import { LOVERS_TRACKING, QUIZ_ROUTE } from '..';

const CHOICES = [
  {
    id: 1,
    text: 'components.LoversQuiz.Steps.Gender.choices.1',
    tracking: 'female',
  },
  {
    id: 2,
    text: 'components.LoversQuiz.Steps.Gender.choices.2',
    tracking: 'male',
  },
  {
    id: 3,
    text: 'components.LoversQuiz.Steps.Gender.choices.3',
    tracking: 'either',
  },
];

const section = {
  sectionName: 'gender',
  choices: CHOICES,
};

const Gender = () => {
  return (
    <StepWithOptions
      hasBackButton={false}
      question={{
        id: 'components.LoversQuiz.Steps.Gender.question',
      }}
      section={section}
      tracking={{ name: LOVERS_TRACKING, url: `${QUIZ_ROUTE}/gender` }}
    />
  );
};

export default Gender;
